import routes from "../../../../../../../Routes/routes";
import {NO_DEPARTMENT, TABS_ATTENDANCE} from "../../../Model/Model";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const ATTENDANCE_SUBMISSION_HISTORY_MODEL ={
    departmentId :null ,
    startDate: null,
    endDate: null,
}

export const handleSubmissionDetails = (url, row, navigate, currentSubView, submissionHistoryFilters = null) => {
    navigate(url, {
        state: {
            backUrl: routes.attendance.main,
            currentTab: TABS_ATTENDANCE.SUBMISSIONS.INDEX,
            currentSubView: currentSubView,
            // Filters of the list the detail was opened from, so going back rebuilds it.
            submissionHistoryFilters
        }
    });
};

export const SUBMISSION_HISTORY_SEARCH_TYPE = {
    ALL_DEPARTMENTS: 0,
    DEPARTMENT_NULL: 1,
    BY_DEPARTMENT: 2
}

export const getSubmissionSearchType = (departmentId) => {
    let attendanceSearchType = SUBMISSION_HISTORY_SEARCH_TYPE.ALL_DEPARTMENTS;
    if(departmentId === NO_DEPARTMENT)
        attendanceSearchType = SUBMISSION_HISTORY_SEARCH_TYPE.DEPARTMENT_NULL;
    else if(departmentId)
        attendanceSearchType = SUBMISSION_HISTORY_SEARCH_TYPE.BY_DEPARTMENT;

    return attendanceSearchType;
}
